import { StyledComponent } from '@emotion/styled';
import { Paper, PaperProps, styled } from '@mui/material';

export const PaperStyled: StyledComponent<PaperProps> = styled(Paper)(({ theme }) => ({
  '&.section-box-error': {
    boxShadow:
      '0px 2px 4px -1px rgb(255 0 0 / 20%), 0px 4px 5px 0px rgb(255 0 0 / 14%), 0px 1px 10px 0px rgb(255 0 0 / 12%);',
    border: `1px solid ${theme.palette.error.main}`
  },
  padding: '16px 24px',
  boxSizing: 'border-box',
  height: '100%',
  '& .MuiGrid-direction-xs-column > .MuiGrid-item': {
    width: '100%'
  }
}));
